"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedBullTVLinearStream1Schema = void 0;
exports.RedBullTVLinearStream1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-linear-stream/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "RedBullTVLinearStream1",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:redbull_tv-linear-stream:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "streamId": {
                    "type": "string",
                    "description": "Stream ID (e.g. bike)"
                }
            },
            "required": [
                "streamId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9yZWRidWxsX3R2LWxpbmVhci1zdHJlYW0vMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxLQUFLLEVBQUUsNkZBQTZGO0lBQ3BHLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHdCQUF3QjtJQUNqQyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04scURBQXFEO2FBQ3REO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osVUFBVSxFQUFFO29CQUNWLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsdUJBQXVCO2lCQUN2QzthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFVBQVU7YUFDWDtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9